// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dgrid-hider-toggle {
	background-position: 0 -192px;
	background-color: transparent;
	border: none;
	cursor: pointer;
	position: absolute;
	right: 0;
	top: 0;
}

.dgrid-rtl-swap .dgrid-hider-toggle {
	right: auto;
	left: 0;
}

.dgrid-hider-menu {
	position: absolute;
	top: 0;
	right: 17px;
	width: 184px;
	background-color: #fff;
	border: 1px solid black;
	z-index: 99999;
	padding: 4px;
	overflow-x: hidden;
	overflow-y: auto;
}

.dgrid-rtl-swap .dgrid-hider-menu {
	right: auto;
	left: 17px;
}

.dgrid-hider-menu-row {
	position: relative;
	padding: 2px;
}
.dgrid-hider-menu-check {
	position: absolute;
	top: 2px;
	left: 2px;
	padding: 0;
}
.dgrid-hider-menu-label {
	display: block;
	padding-left: 20px;
}

html.has-quirks .dgrid-hider-menu-check,
html.has-ie-6-7 .dgrid-hider-menu-check {
	/* IE < 8 seems to ignore padding: 0, so counteract */
	top: 0;
	left: 0;
}

#dgrid-css-extensions-ColumnHider-loaded {
	display: none;
}
`, "",{"version":3,"sources":["webpack://./target/debug/2P/derived/ui/dgrid/css/extensions/ColumnHider.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;CAC7B,6BAA6B;CAC7B,YAAY;CACZ,eAAe;CACf,kBAAkB;CAClB,QAAQ;CACR,MAAM;AACP;;AAEA;CACC,WAAW;CACX,OAAO;AACR;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,uBAAuB;CACvB,cAAc;CACd,YAAY;CACZ,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;AACX;AACA;CACC,cAAc;CACd,kBAAkB;AACnB;;AAEA;;CAEC,qDAAqD;CACrD,MAAM;CACN,OAAO;AACR;;AAEA;CACC,aAAa;AACd","sourcesContent":[".dgrid-hider-toggle {\n\tbackground-position: 0 -192px;\n\tbackground-color: transparent;\n\tborder: none;\n\tcursor: pointer;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n}\n\n.dgrid-rtl-swap .dgrid-hider-toggle {\n\tright: auto;\n\tleft: 0;\n}\n\n.dgrid-hider-menu {\n\tposition: absolute;\n\ttop: 0;\n\tright: 17px;\n\twidth: 184px;\n\tbackground-color: #fff;\n\tborder: 1px solid black;\n\tz-index: 99999;\n\tpadding: 4px;\n\toverflow-x: hidden;\n\toverflow-y: auto;\n}\n\n.dgrid-rtl-swap .dgrid-hider-menu {\n\tright: auto;\n\tleft: 17px;\n}\n\n.dgrid-hider-menu-row {\n\tposition: relative;\n\tpadding: 2px;\n}\n.dgrid-hider-menu-check {\n\tposition: absolute;\n\ttop: 2px;\n\tleft: 2px;\n\tpadding: 0;\n}\n.dgrid-hider-menu-label {\n\tdisplay: block;\n\tpadding-left: 20px;\n}\n\nhtml.has-quirks .dgrid-hider-menu-check,\nhtml.has-ie-6-7 .dgrid-hider-menu-check {\n\t/* IE < 8 seems to ignore padding: 0, so counteract */\n\ttop: 0;\n\tleft: 0;\n}\n\n#dgrid-css-extensions-ColumnHider-loaded {\n\tdisplay: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
